/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_TitleInputs */

const vi_fertilizer_title = /** @type {(inputs: Fertilizer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón`)
};

/**

* @param {Fertilizer_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_title = /** @type {((inputs?: Fertilizer_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_title(inputs)
});